module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-sessionLab"
  }, [_c('div', {
    staticClass: "headBox"
  }, [_c('span', {
    staticClass: "headBox-title"
  }, [_vm._v(_vm._s(_vm.Language('会话标签')))]), _vm._v(" "), _c('span', {
    staticClass: "headBox-val"
  }, [_vm._v(_vm._s(_vm.selectedList))])]), _vm._v(" "), _c('div', {
    staticClass: "searchInput"
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.Language('搜索标签')))]), _vm._v(" "), _c('el-cascader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.labelActive == 1),
      expression: "labelActive==1"
    }],
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "",
      "options": _vm.optionsList,
      "props": _vm.props,
      "filterable": ""
    },
    on: {
      "change": _vm.handleChangeFn
    },
    model: {
      value: (_vm.selectedLablist),
      callback: function($$v) {
        _vm.selectedLablist = $$v
      },
      expression: "selectedLablist"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.labelActive == 2),
      expression: "labelActive==2"
    }],
    staticStyle: {
      "width": "220px",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "input": _vm.handleSearchFn
    },
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "labelListBox"
  }, [_c('el-tabs', {
    staticClass: "notRight tabs-title labelList",
    attrs: {
      "tab-position": "top"
    },
    model: {
      value: (_vm.labelActive),
      callback: function($$v) {
        _vm.labelActive = $$v
      },
      expression: "labelActive"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.Language('普通标签'),
      "name": "1"
    }
  }, [(_vm.labelActive == 1) ? _c('el-cascader-panel', {
    ref: "myCascader",
    attrs: {
      "options": _vm.optionsList,
      "props": _vm.props
    },
    on: {
      "change": _vm.handleChangeFn
    },
    model: {
      value: (_vm.selectedLablist),
      callback: function($$v) {
        _vm.selectedLablist = $$v
      },
      expression: "selectedLablist"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.Language('热点标签'),
      "name": "2"
    }
  }, [_c('el-checkbox-group', {
    staticClass: "hotLabelBox",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.hotSelected),
      callback: function($$v) {
        _vm.hotSelected = $$v
      },
      expression: "hotSelected"
    }
  }, _vm._l((_vm.hotPointList), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      staticClass: "hotLabelItem",
      attrs: {
        "border": "",
        "label": item.labName + item.id
      },
      on: {
        "change": function($event) {
          return _vm.hotLabelFn($event, item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.labName))]), _vm._v(" "), _c('span', {
      attrs: {
        "title": item.namePath
      }
    }, [_vm._v(_vm._s(item.namePath))])])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btnList"
  }, [_c('p', {
    staticClass: "pt-5 mr-10 fl"
  }, [_vm._v("备注信息")]), _vm._v(" "), _c('el-input', {
    staticClass: "fl",
    staticStyle: {
      "width": "calc(100% - 215px)"
    },
    attrs: {
      "placeholder": "",
      "size": "small",
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleComitFn(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleComitFn(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('确 定')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4af5a43c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SessionLab.vue
// module id = 1332
// module chunks = 5